import type { ReactNode } from "react";
import type { Binding } from "@/app/types";
import { CollapsibleResourceSection } from "./collapsible-resource-section";

type ResourceSection = {
  binding: Binding;
  itemsCount: number;
  resourceType: string;
  defaultOpen?: boolean;
  overriddenCount?: number;
  overriddenTooltipContent?: string;
  children?: ReactNode;
};

type VerticalResourceViewProps = {
  sections: ResourceSection[];
};

export const VerticalResourceView = ({
  sections,
}: VerticalResourceViewProps) => {
  if (sections.length === 0) {
    return (
      <div className="rounded-lg border border-border/40 py-12 text-center text-muted-foreground">
        <p>No resources to display</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {sections.map((section, index) => (
        <CollapsibleResourceSection
          binding={section.binding}
          defaultOpen={section.defaultOpen ?? index === 0}
          itemsCount={section.itemsCount}
          key={`${section.binding}-${section.resourceType}`}
          overriddenCount={section.overriddenCount} // First section open by default
          overriddenTooltipContent={section.overriddenTooltipContent}
          resourceType={section.resourceType}
        >
          {section.children}
        </CollapsibleResourceSection>
      ))}
    </div>
  );
};
